var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verify-content" }, [
    _c("div", {
      staticClass: "blue-heading",
      domProps: {
        innerHTML: _vm._s(
          _vm.$t(
            "Account.SequentialVerification.VerifyByPin.Verification.Detail." +
              _vm.detail
          )
        )
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "padding-separate" }, [
      !_vm.translationsLoaded
        ? _c("div", [_c("circle-loader")], 1)
        : _c("div", [
            _c(
              "div",
              { staticClass: "account-page ctsform" },
              [
                _c(
                  "form",
                  [
                    _vm.showLoader
                      ? _c("loader", { staticClass: "ver-loader" })
                      : _vm._e(),
                    _vm._v(" "),
                    !(_vm.verifyMob || _vm.verifyEmail) &&
                    !_vm.changeEmailOrPhoneVisible &&
                    !_vm.showLoader
                      ? _c("div", { staticClass: "form-actions" }, [
                          _c("div", { staticClass: "control-block" }, [
                            _c(
                              "div",
                              { staticClass: "flex-between margin-t-10" },
                              [
                                _c("div", [
                                  _vm.personalDetails && _vm.detail === "email"
                                    ? _c("p", { staticClass: "verifyText" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.personalDetails.PrimaryEmail
                                          )
                                        )
                                      ])
                                    : _vm.personalDetails &&
                                      _vm.detail === "phone"
                                    ? _c("p", { staticClass: "verifyText" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.personalDetails.MobilePhone
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm.detail === "email" && _vm.isEmailVerified
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-blue font-600 flex-center"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.Verified"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "icon-verified"
                                          })
                                        ]
                                      )
                                    : _vm.detail === "email" &&
                                      !_vm.isEmailVerified
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-red font-600 flex-center"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.NonVerified"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "icon-not-verified"
                                          })
                                        ]
                                      )
                                    : _vm.detail === "phone" &&
                                      _vm.isPhoneVerified
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-blue font-600 flex-center"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.Verified"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "icon-verified"
                                          })
                                        ]
                                      )
                                    : _vm.detail === "phone" &&
                                      !_vm.isPhoneVerified
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-red font-600 flex-center"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "Account.SequentialVerification.VerifyByPin.Verification.Detail.Status.NonVerified"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "icon-not-verified"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex-between" }, [
                            _c(
                              "div",
                              { staticClass: "control-block" },
                              [
                                _c("v-card-text", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Account.SequentialVerification.VerifyByPin.Verification.EnteredWrongData",
                                        { wrongDetail: _vm.detail }
                                      )
                                    ) + " "
                                  ),
                                  _c("u", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ver_pointer color-red font-600",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.changeDetails()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.EditHere"
                                            )
                                          ) + " "
                                        ),
                                        _c(
                                          "v-icon",
                                          { staticClass: "color-red" },
                                          [_vm._v("chevron_right")]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            (_vm.detail === "email" && !_vm.isEmailVerified) ||
                            (_vm.detail === "phone" && !_vm.isPhoneVerified)
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "success",
                                          type: "submit",
                                          "x-large": ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.resendPin()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Account.SequentialVerification.VerifyByPin.Verification.Verify"
                                              )
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "verification-info" }, [
                            _vm.detail === "phone"
                              ? _c("div", [
                                  _vm.isPhoneVerified
                                    ? _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.Phone.Verified"
                                            )
                                          )
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.Phone.NotVerified"
                                            )
                                          )
                                        }
                                      })
                                ])
                              : _vm.detail === "email"
                              ? _c("div", [
                                  _vm.isEmailVerified
                                    ? _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.Email.Verified"
                                            )
                                          )
                                        }
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "Account.SequentialVerification.VerifyByPin.Verification.Email.NotVerified"
                                            )
                                          )
                                        }
                                      })
                                ])
                              : _vm._e()
                          ])
                        ])
                      : !_vm.changeEmailOrPhoneVisible && !_vm.showLoader
                      ? _c("div", [
                          _vm.verifyMob && !_vm.isPhoneVerified
                            ? _c(
                                "div",
                                [
                                  _c("verify-by-pin", {
                                    attrs: {
                                      page: "verify_mob",
                                      state: "sent"
                                    },
                                    on: {
                                      changeDetailPhone: _vm.changeDetails,
                                      refreshafteraction: _vm.updateCom
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("verify-by-pin", {
                                    attrs: {
                                      page: "verify_email",
                                      state: "sent"
                                    },
                                    on: {
                                      changeDetailEmail: _vm.changeDetails,
                                      refreshafteraction: _vm.updateCom
                                    }
                                  })
                                ],
                                1
                              )
                        ])
                      : _vm.changeEmailOrPhoneVisible && !_vm.showLoader
                      ? _c("div", [
                          _vm.detail === "phone"
                            ? _c(
                                "div",
                                [
                                  _c("ChangeDetail", {
                                    attrs: { page: "verify_mob" },
                                    on: {
                                      goBackPhone: _vm.changeDetails,
                                      updateCom: _vm.updateCom,
                                      changeDetail: _vm.changeDetails
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm.detail === "email"
                            ? _c(
                                "div",
                                [
                                  _c("ChangeDetail", {
                                    attrs: { page: "verify_email" },
                                    on: {
                                      goBackEmail: _vm.changeDetails,
                                      updateCom: _vm.updateCom,
                                      changeDetail: _vm.changeDetails
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ProcessingDialog",
                  {
                    attrs: {
                      isDialogPersistent: true,
                      isProcessing: _vm.isProcessing,
                      isSuccess: !_vm.transactionError,
                      processingTitle: _vm.processingTitle,
                      processingText: _vm.processingText,
                      successTitle: _vm.successTitle,
                      successText: _vm.successText,
                      errorTitle: _vm.errorTitle,
                      closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
                    },
                    on: { close: _vm.closeVerificationDialog },
                    model: {
                      value: _vm.dialog,
                      callback: function($$v) {
                        _vm.dialog = $$v
                      },
                      expression: "dialog"
                    }
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "text-error" }, slot: "text-error" },
                      [
                        _c(
                          "p",
                          { staticClass: "generic-icon-note" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { color: "error" }
                              },
                              [_vm._v("error")]
                            ),
                            _c("span", [_vm._v(_vm._s(_vm.errorText))])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "response-error" }, [
                          _vm._v(_vm._s(_vm.transactionError))
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "Account.Join.Dialog.Error.Text.ContactSupport"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff1bdb48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff1bdb48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/VerifyDetail.vue
// module id = null
// module chunks = 